export default __webpack_public_path__ + "static/media/a037-dateofBirth-05.099f5e48.png";